export default function (phrase, params) {
    // @TODO
    // do the thing
    if (!params) {
        return phrase
    }

    return phrase.replace(/\{(\w+)\}/g, (match, key) =>
        Object.prototype.hasOwnProperty.call(params, key) ? params[key] : match
    )
}
